<template>
    <div class="dialog" >
        <div class="card_card-container_3IqIB">
            <div class="card_card_1GGVI">
                <div class="card_header-buttons_qyTyG">
                    <div class="card_all-button_2Cjp1">{{title}}</div>
                    <div class="card_steps-list_Go4Y3">
                        <div :class="index==current?'card_active-step-pip_1FVD5': 'card_inactiveStepPip_3M7NO'"  v-for="(item,index) in list" :key="index"></div>
                    </div>
                    <div class="card_header-buttons-right_1C3ue">
                        <div class="card_shrink-expand-button_22uRf" @click="contentVisibility=!contentVisibility"><span>{{contentVisibility?'收起':'展开'}}</span></div>
                        <div class="card_remove-button_2ax7L" @click.stop="$emit('close')"><span>关闭</span></div>
                    </div>
                </div>
                <div class="card_step-body_2J0pk" v-show="contentVisibility" v-if="list.length>0">
                    <div class="card_step-title_EI5Iq" v-if="list[current].type !== 2">{{list[current].name}}</div>
                    <div v-if="list[current].type === 0"> {{list[current].content}}</div>
                      <div v-if="list[current].type === 1"> 
                          <img :src="list[current].url" alt="" style="max-width:600px">
                      </div>
                      <div v-if="list[current].type === 2"> 
                          <video style='max-width: 900px' controls autoplay="autoplay">
                            <source :src="list[current].url" />
                        </video>
                      </div>
                </div>
                <div v-if="contentVisibility">
                    <div class="card_right-button_3XNZw" @click="current+=1" v-if="current<list.length-1">
                        <img draggable="false" src="../assets/arrow-right.svg">
                        </div>
                    <div class="card_left-button_13EDK" @click="current-=1" v-if="current>0">
                        <img draggable="false" src="../assets/icon-prev.svg">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'bar',
    props: {
      title: {
        type: String,
        default: ''
      },
     
      type: {
          type: Number,
          default: 1 , // 1表示 任务弹框， 2： 表示视频弹框
      },
      bookSubInfo:{
          type: Object
      },
      taskList: {
          type: Array,
      }
    },

    data () {
    let list =[]
      if(this.type === 1){
        list = this.taskList
      }else{
          list = [{
              name: this.bookSubInfo.name,
              type: 2,
              url: this.bookSubInfo.mp4
          }]
      }
      return {
        list,
        current: 0,
        contentVisibility:true
      }
    }
  }
</script>

<style lang="less" scoped>
    .dialog {
        top: 48px;
        left: -200px;
        position: fixed;
        pointer-events: none;
        z-index: 2000;
    }

    .card_card-container_3IqIB {
        position: absolute;
        pointer-events: auto;
        z-index: 480;
        margin: 0.5rem 2rem;
        min-width: 468px;
        touch-action: none;
        transform: translate(732px, 77px);
    }

    .card_card_1GGVI {
        border: 1px solid hsla(215, 50%, 90%, 1);
        border-radius: 0.75rem;
        display: flex;
        flex-direction: column;
        cursor: move;
        z-index: 20;
        overflow: hidden;
        box-shadow: 0px 5px 25px 5px hsla(0, 0%, 0%, 0.15);
        align-items: center;
    }

    .card_text-step-p_1J2-8 {
        text-align: left;
    }

    .card_card-container-overlay_3CqGa {
        position: fixed;
        pointer-events: none;
        z-index: 480;
    }

    .card_card-container_3IqIB {
        position: absolute;
        pointer-events: auto;
        z-index: 480;
        margin: 0.5rem 2rem;
        min-width: 468px;
    }

    .card_left-card_jwHT9, .card_right-card_3y2mC {
        height: 90%;
        position: absolute;
        top: 5%;
        background: hsla(0, 100%, 100%, 1);
        border: 1px solid hsla(215, 50%, 90%, 1);
        width: .75rem;
        z-index: 10;
        opacity: 0.9;
        overflow: hidden;
    }

    .card_left-card_jwHT9 {
        left: -.75rem;
        border-right: 0;
        border-top-left-radius: 0.75rem;
        border-bottom-left-radius: 0.75rem;
    }

    .card_right-card_3y2mC {
        right: -.75rem;
        border-left: 0;
        border-top-right-radius: 0.75rem;
        border-bottom-right-radius: 0.75rem;
    }

    .card_left-card_jwHT9::after, .card_right-card_3y2mC::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        height: 2.5rem;
        width: 100%;
        background: hsla(163, 85%, 40%, 1);
    }

    .card_left-button_13EDK, .card_right-button_3XNZw {
        position: absolute;
        top: 50%;
        margin-top: -15px;
        z-index: 20;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor: pointer;
        background: hsla(163, 85%, 40%, 1);
        -webkit-box-shadow: 0 0 0 4px hsla(163, 85%, 40%, 0.35);
        box-shadow: 0 0 0 4px hsla(163, 85%, 40%, 0.35);
        height: 44px;
        width: 44px;
        border-radius: 100%;

        display: flex;
        justify-content: center;

        align-items: center;
        transition: all 0.25s ease;
    }

    .card_left-button_13EDK:hover, .card_right-button_3XNZw:hover {
        box-shadow: 0 0 0 6px hsla(163, 85%, 40%, 0.35);

        transform: scale(1.125);
    }

    .card_left-button_13EDK img, .card_right-button_3XNZw img {
        width: 1.75rem;
    }

    .card_left-button_13EDK {
        left: -27px;
    }

    .card_right-button_3XNZw {
        right: -27px;
    }

    .card_card_1GGVI {
        border: 1px solid hsla(215, 50%, 90%, 1);
        border-radius: 0.75rem;
        display: flex;
        -ms-flex-direction: column;
        flex-direction: column;
        cursor: move;
        z-index: 20;
        overflow: hidden;
        box-shadow: 0px 5px 25px 5px hsla(0, 0%, 0%, 0.15);
        -ms-flex-align: center;
        align-items: center;
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    }

    .card_header-buttons_qyTyG {
        width: 100%;

        display: flex;
        flex-direction: row;

        -ms-flex-pack: justify;
        justify-content: space-between;
        -ms-flex-align: center;
        align-items: center;
        background: hsla(163, 85%, 40%, 1);
        border-bottom: 1px solid hsla(163, 85%, 30%, 1);
        font-size: 0.625rem;
        font-weight: bold;
    }

    .card_header-buttons-hidden_Yp-5F {
        border-bottom: 0px;
    }

    .card_header-buttons-right_1C3ue {
        display: flex;

        -ms-flex-direction: row;
        flex-direction: row;
    }

    .card_header-buttons_qyTyG img {
        margin-bottom: 2px;
    }

    .card_shrink-expand-button_22uRf {
        cursor: pointer;
        color: white;
        display: flex;
        flex-direction: column;
        -ms-flex-pack: center;
        justify-content: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 0.75rem;
    }

    .card_shrink-expand-button_22uRf:hover, .card_all-button_2Cjp1:hover {
        background-color: hsla(0, 0%, 0%, 0.15);
    }

    .card_remove-button_2ax7L, .card_all-button_2Cjp1 {
        cursor: pointer;
        color: white;
        display: flex;
        -ms-flex-direction: column;
        flex-direction: column;
        -ms-flex-pack: center;
        justify-content: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 0.75rem;
    }

    .card_remove-button_2ax7L:hover, .card_all-button_2Cjp1:hover {
        background-color: hsla(0, 0%, 0%, 0.15);
    }

    .card_step-title_EI5Iq {
        font-size: 0.9rem;
        margin: 0.9rem;
        text-align: center;
        font-weight: bold;
        color: hsla(225, 15%, 40%, 1);
    }

    .card_step-body_2J0pk {
        width: 100%;
        background: hsla(0, 100%, 100%, 1);
        display: flex;
        flex-direction: column;

        -ms-flex-pack: center;
        justify-content: center;
        -ms-flex-align: center;
        align-items: center;
        position: relative;
        text-align: center;

        /* Min height prevents layout changing when images change */
        min-height: 256px;
    }

    .card_step-video_25VTw {
        height: 256px;
    }

    .card_step-image_1uMDC {
        max-width: 520px;
        /*max-height: 400px;*/
        -o-object-fit: contain;
        object-fit: contain;
        background: #F9F9F9;
        border: 1px solid #ddd;
        border-radius: 0.5rem;
        overflow: hidden;
        margin: 0 1.5rem 1.5rem;
    }

    .card_decks_1jfRb {

        display: flex;

        flex-direction: row;
        justify-content: space-around;
        padding: 0 1rem 0.5rem;
    }

    .card_deck_B2IxE {
        display: flex;
        flex-direction: column;
        margin: 0 8px 8px;
        cursor: pointer;
        border: 1px solid hsla(0, 0%, 0%, 0.15);
        border-radius: 0.25rem;
        overflow: hidden;
    }

    .card_deck-image_2ESnL {
        width: 200px;
        height: 100px;
        -o-object-fit: cover;
        object-fit: cover;
    }

    .card_deck-name_1aIfj {
        color: hsla(215, 100%, 65%, 1);
        font-weight: bold;
        font-size: 0.85rem;
        margin: .625rem 0px;
        text-align: center;
        font-weight: bold;
        text-align: center;
        max-width: 200px;
    }

    .card_help-icon_1jDA- {
        height: 1.25rem;
    }

    .card_close-icon_1AGFj {
        height: 1.25rem;
        margin: .125rem 0; /* To offset the .25rem difference in icon size */
    }

    [dir="ltr"] .card_help-icon_1jDA- {
        margin-right: 0.25rem;
    }

    [dir="rtl"] .card_help-icon_1jDA- {
        margin-left: 0.25rem;
    }

    [dir="ltr"] .card_close-icon_1AGFj {
        margin-left: 0.25rem;
    }

    [dir="rtl"] .card_close-icon_1AGFj {
        margin-right: 0.25rem;
    }

    .card_see-all_29d1d {
        display: flex;
        flex-direction: row;
        justify-content: center;
        width: 100%;
        padding: 0.5rem;
    }

    .card_see-all-button_bj3K4 {
        cursor: pointer;
        padding: 0.5rem 1rem;
        background-color: hsla(215, 100%, 65%, 1);
        color: white;
        font-weight: bold;
        border-radius: 0.25rem;

        display: flex;
        -ms-flex-align: center;
        align-items: center;
        color: hsla(0, 100%, 100%, 1);
        font-size: .75rem;
        font-weight: bold;
        line-height: 1rem;
        text-align: center;
    }

    [dir="ltr"] .card_see-all-button_bj3K4 img {
        margin-left: 0.5rem;
    }

    [dir="rtl"] .card_see-all-button_bj3K4 img {
        margin-right: 0.5rem;
    }

    .card_steps-list_Go4Y3 {

        display: flex;

        flex-direction: row;
        justify-content: center;

        align-items: center;
    }

    .card_active-step-pip_1FVD5, .card_inactiveStepPip_3M7NO {
        width: 0.5rem;
        height: 0.5rem;
        margin: 0 0.25rem;
        border-radius: 100%;
        background: hsla(0, 100%, 100%, 0.25);
    }

    .card_active-step-pip_1FVD5 {
        background: hsla(0, 100%, 100%, 1);
        box-shadow: 0px 0px 0px 2px hsla(0, 0%, 0%, 0.15);
    }

    .card_hidden_2s3Qt {
        display: none;
    }

</style>



// WEBPACK FOOTER //
// src/components/Dialog.vue